import { environment } from '@environments/environment';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class ActionPlanServices {
    // eslint-disable-next-line
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.sendPositionSubject = new BehaviorSubject([]);
        this.sendPositioObservable = this.sendPositionSubject.asObservable();
    }
    getOperationNumber(isMyactionPlan) {
        return this.httpClient.get(environment.api.base + 'actionplan/GetActionPlanListByRole?isMyactionPlan=' + ((isMyactionPlan == true) ? "SI" : "NO"));
    }
    getActionPlanByOperationNumber(idActionPlan) {
        return this.httpClient.get(environment.api.base + 'actionplan/GetActionPlanListByAnalisisId?IdActionPlan=' + idActionPlan);
    }
    getCloneActionPlan(actionPlanId) {
        return this.httpClient.put(environment.api.base + 'actionplan/CloneActionPlan?actionPlanId=' + actionPlanId, {});
    }
    /*getExternalUserByMail(mail) {
      return this.httpClient.get(environment.api.base + 'ExternalUser/GetExternalUserByMail?mail='+mail);
    }*/
    upDateActionPlan(listActionPlan) {
        console.log('flag5');
        return this.httpClient.put(environment.api.base + 'actionplan', listActionPlan);
    }
    deleteCloneActionPlan(actionPlanId) {
        return this.httpClient.put(environment.api.base + 'actionplan/DeleteCloneActionPlan?actionPlanId=' + actionPlanId, {});
    }
}
ActionPlanServices.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ActionPlanServices_Factory() { return new ActionPlanServices(i0.ɵɵinject(i1.HttpClient)); }, token: ActionPlanServices, providedIn: "root" });
